import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { priceLabels } from 'cache';
import { PriceLabel } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const PriceLabelsFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const priceLabelsOptions = Object.values(PriceLabel);
  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.priceLabel.label' })}</EuiFormLabel>
      <EuiComboBox
        placeholder={formatMessage({ id: 'filters.priceLabel.placeholder' })}
        options={priceLabelsOptions.map((x) => ({ label: formatMessage({ id: `priceIndicators.${x}` }), value: x }))}
        selectedOptions={localFilters?.data?.priceLabels?.map((x: string) => ({
          label: formatMessage({ id: `priceIndicators.${x}` }),
          value: x,
        }))}
        onChange={(x: EuiComboBoxOptionOption<string>[]): string[] | undefined =>
          priceLabels(x?.map(({ value }) => value) as string[])
        }
      />
    </S.SidebarFilterWrapper>
  );
};
